export default __webpack_public_path__ + "static/media/3P_Icon.44231caf.svg";